import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DeviceDetectionService {
  constructor() {}

  // Function to check if the device is an Android phone
  isAndroid(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return /android/.test(userAgent);
  }

  // Function to check if the device is a Laptop/Desktop
  isLaptop(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return !/android|mobile|iphone|ipad|ipod|windows phone|blackberry|opera mini|iemobile|mobile/i.test(
      userAgent
    );
  }
}
